module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mo-8027f57edf20f3825fad806145771f7d.svg";